import React from "react";
import { Text } from "@jsq/ds/core";

export const ThisPositionOnly: React.FC = () => {
  return (
    <div>
      <Text>This payment instruction will be applied to this position only</Text>
    </div>
  );
};
